import { Component, OnInit } from '@angular/core';
import { NewsService } from '../services/news.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'all-news',
  templateUrl: './all-news.component.html',
  styleUrls: ['./all-news.component.css']
})
export class AllNewsComponent implements OnInit {

  news :any[]

  constructor(private myNews:NewsService  , private _router:Router) 
  {
    this.news = this.myNews.newsData ; 
     }

  ngOnInit() {

    $(document).ready(function(){
      $(".accor li ").click(function(){
        
        if($(this).attr("id") == "1")
        {
         $(".firs").css("display","block");
          $(".sec").css("display","none");  
           $(this).addClass("act");
           $(this).siblings().removeClass("act"); 
          
      
        
        }
        else
        {
          
          $(".sec").css("display","block");
          $(".firs").css("display","none"); 
          $(this).addClass("act");
           $(this).siblings().removeClass("act"); 
        
        }
      });
    });
  }
  changeURL(tag)
  {
    
    this._router.navigate(["News/Tag",tag])
  }
  changeWritter(author)
  {
    this._router.navigate(["News/Writter",author])
  }

}
